import { useApp } from '../../../../../context/App';
import { INews } from '../../../../../types/news';
import { parseDate } from "../../../../../utils/date";

interface Props {
	news: INews
}

export function MainNews({ news }: Props) {
	const { configDomainURL } = useApp()
	const domain = configDomainURL
	const link_montado = news.title
		.toLowerCase()
		.replaceAll(' ', '-')
		.replaceAll('/', '-')
		.replaceAll(new RegExp('[&/\\\\#,+()$~%.\'":*?<>{}]', 'g'), '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, "")

	const MainNews_img = 'https://api-portal.itajai.sc.gov.br/public/portaladm-pmitajai/noticias/foto/' + news.img

	return (
		<a
			href={`${domain}noticias/${news.newsId}/${link_montado}`}
			className="w-full col-span-1 lg:col-span-7 flex flex-col bg-surface-secondary dark:bg-surface-dark-secondary rounded-2xl overflow-hidden no-underline group shadow-md dark:shadow-premium-dark hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] border border-border-default dark:border-white/10"
		>
			{!!news.img && (
				<div className="relative overflow-hidden aspect-[4/3] lg:aspect-[2.3/1] w-full bg-surface-alt dark:bg-surface-dark">
					<img
						src={MainNews_img}
						className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 dark:opacity-90 dark:group-hover:opacity-100"
						alt={news.title}
						loading="lazy"
					/>
					<div className="absolute top-4 left-4 bg-secondary text-primary px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider shadow-md">
						Mais recente
					</div>
				</div>
			)}

			<div className="p-5 flex flex-col gap-2">
				<span className="text-on-surface-subtle dark:text-on-surface-dark-muted font-medium text-xs uppercase tracking-widest">
					{parseDate(news.published)}
				</span>
				<h3 className="text-on-surface dark:text-on-surface-dark font-bold text-xl lg:text-[1.60rem] leading-tight transition-colors duration-200 group-hover:text-primary dark:group-hover:text-secondary">
					{news.title}
				</h3>
				<p className="text-on-surface-subtle dark:text-on-surface-dark-muted text-sm lg:text-base line-clamp-3 leading-relaxed">
					{news.subtitle}
				</p>
			</div>
		</a>
	)
}